// src/services/produtos/ProdutoHorarioService.js
import { fetchData, postData, deleteData } from '../Api';

export const buscarHorariosProduto = async (produtoId) => {
    const result = await fetchData('/ProdutoPedidoDia', { produtoId });
    return Array.isArray(result) ? result : [];
};

export const salvarHorariosProduto = async (registrosAtuais, payload) => {
    if (registrosAtuais.length > 0) {
        await Promise.all(registrosAtuais.map(item => deleteData(`/ProdutoPedidoDia/${item.id}`)));
    }
    if (payload.length > 0) {
        await Promise.all(payload.map(item => postData('/ProdutoPedidoDia', item)));
    }
};
